import { Box, FormHelperText, IconButton, Typography, useMediaQuery, useTheme, Theme } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useState, useEffect } from 'react';
import OtpInput, { InputProps } from 'react-otp-input';
import { maskMobileNumber } from '../../utils/utilityFunctions';
import { useDispatch } from 'react-redux';
import { getInvestorJointHolderDetails, getInvestorTokenCompany, getUserInfo, newVerifyLoginOtp, showError, verifyLoginEmail, verifyLoginOtp } from '../../redux-store/actions/auth';
import { useHistory } from 'react-router';
import { LoginLayout, OtpTimer } from '../commonComponents';
import { getInvestorTokenWithCompany, getOtpForInvestor, getOtpForPaymentFlow, verifyOtpForInvestor, verifyOtpForPayment } from '../../redux-store/actions/onBoarding';
import { Location } from 'history';
import { loginWithOtp } from '../../redux-store/actions/auth';
import {
  GetInvestorJointHolderDetailsResponseBody,
  GetInvestorTokenCompanyResponseBody,
  GetOtpForInvestorResponse,
  LoginWithOtpResponseBody,
  verifyInvestorResponse,
  VerifyLoginEmailResponseBody,
  VerifyLoginOtpResponseBody,
  VerifyPaymentResponse,
} from '../../redux-store/types/api-types';
import { Formik } from 'formik';
import { MFSubmitButton } from '../../lib/formik';
import { GET_USER_INFO_SUCCESS, LOGOUT_SUCCESS, VERIFY_LOGIN_OTP, VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';
import { USER_ROLES } from '../../utils/constant';
import { storeApplicationId, storeInterfaceCode, storeInvestorClientId, storeIwappId } from '../../redux-store/actions/id';
import { setInvestorRmId } from '../../redux-store/actions/sessionData';
import { InfoIconOutlined } from '../../assets/SvgIcons';

const intialValues: { OTP: string } = {
  OTP: '',
};

interface RouterState extends LoginWithOtpResponseBody, VerifyLoginEmailResponseBody {
  loginType: string;
  referenceId: string;
  paymentId: string;
}

export default function LoginOtp({ location }: { location: Location<RouterState> }): JSX.Element {
  const {
    phone = "",
    email = "",
    countryCode = "",
    userId = null,
    roles = [],
    isEmailVerificationRequired = false,
    unMaskedPhone = "",
    unMaskedEmail = "",
    userRole = "",
    loginType = "",
    referenceId = "",
    paymentId = ""
  } = location.state || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState<string>('');
  const [{ verificationToken }, setVerifyOtpInfo] = useState({ verificationToken: '' });
  const [isLoading, setLoading] = useState<boolean>(false)
  const [isPasswordVisible, setPasswordVisible] = useState<boolean>(false)

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isXs = useMediaQuery(theme.breakpoints.up('xs'));

  const handleSubmit = async (values: { OTP: string }, { resetForm }: { resetForm: () => void }) => {

    // console.log("TYPE", loginType)
    const { OTP } = values;
    try {
      setLoading(true)

      if (!OTP || OTP.length !== 6) {
        setError('Enter OTP');
        return;
      }

      if (loginType === 'payment') {
        try {
          const paymentRes = await (dispatch(verifyOtpForPayment(
            referenceId, {
            otp: OTP,
            verificationToken,
            email: unMaskedEmail ?? "",
            userRole: userRole ?? ""
          })) as unknown) as VerifyPaymentResponse;
          if (paymentRes?.token) {
            const payload = {
              clientCode: paymentRes?.clientCode
            }
            const tokenWithCompanyRes = await (dispatch(getInvestorTokenWithCompany(payload)) as unknown) as verifyInvestorResponse
            if (tokenWithCompanyRes?.token) {
              history.push('payment-details', {
                clientCode: paymentRes?.clientCode,
                portfolioId: paymentRes?.portfolioId
              })
            }
          }
        }
        catch (e) {
          console.log(e);
        };
        return;
      }
      if (loginType === 'investor') {
        const res = await dispatch(verifyOtpForInvestor(
          referenceId, {
          otp: OTP,
          verificationToken,
          email: unMaskedEmail ?? "",
          userRole: userRole ?? ""
        }) as unknown as Promise<verifyInvestorResponse>);
        if (res?.token) {
          await dispatch(getUserInfo());
          history.push(`application-details`);
        }
        return;
      }
      const res = await (dispatch(newVerifyLoginOtp({
        phone: unMaskedPhone ?? "",
        otp: OTP,
        verificationToken: verificationToken ?? "",
        countryCode: countryCode ?? "",
        userRole: userRole ?? "",
        email: unMaskedEmail ?? ""
      })) as unknown) as VerifyLoginOtpResponseBody
      // const res = await (dispatch(verifyLoginOtp({ phone: mobile, otp: OTP, verificationToken, countryCode })) as unknown) as VerifyLoginOtpResponseBody

      if (res?.role === 'investor' && loginType === '') {
        // const jointHolder = await fetch(`api/onboarding/dashboard/getInvestorDetails`, {
        //   method: 'GET',
        //   headers: {
        //     Accept: "application/json",
        //     "Content-Type": "application/json",
        //     Expires: '0',
        //     Authorization: "Bearer " + (res.token || '') as string
        //   },
        // }).then((res) => res.json())

        const jointHolder = await dispatch(getInvestorJointHolderDetails({
          temporaryToken: res?.token,
          body: {
            email: res?.roles?.[0]?.email ?? ""
          }
        }) as unknown as Promise<GetInvestorJointHolderDetailsResponseBody>)



        if (jointHolder.isSuccess) {
          if (jointHolder?.data?.accountList?.length === 1) {
            dispatch(storeInvestorClientId({ investorClientId: jointHolder?.data?.accountList[0]?.clientCode }));
            dispatch(storeInterfaceCode(jointHolder?.data?.accountList[0]?.clientInterfaceCode));
            dispatch(storeIwappId({ iwappRmId: jointHolder?.data?.accountList[0]?.rmId ?? "" }));
            dispatch(setInvestorRmId(jointHolder?.data?.accountList[0]?.rmId ?? ''))

            const showDiyInvestorOnboarding = jointHolder?.data?.accountList?.[0]?.status?.toLowerCase() === "draft"
            const showDiyInvOnboardingPrev = !['draft', 'completed'].includes(jointHolder?.data?.accountList?.[0]?.status?.toLowerCase());

            // const tokenWithCompanyRes = await fetch(`api/users/users/generate-investor-token-with-company`, {
            //   method: 'POST',
            //   headers: {
            //     Accept: "application/json",
            //     "Content-Type": "application/json",
            //     Expires: '0',
            //     Authorization: "Bearer " + (res?.token || '') as string
            //   },
            //   body: JSON.stringify({ clientCode: jointHolder?.data?.accountList?.[0]?.clientCode, applicationId: jointHolder?.data?.accountList?.[0]?.id })
            // }).then((res) => res.json())

            const tokenWithCompanyRes = await dispatch(getInvestorTokenCompany({
              clientCode: jointHolder?.data?.accountList?.[0]?.clientCode,
              applicationId: jointHolder?.data?.accountList?.[0]?.id,
              temporaryToken: res?.token
            }) as unknown as Promise<GetInvestorTokenCompanyResponseBody>)


            if (tokenWithCompanyRes.isSuccess) {
              dispatch(storeApplicationId({ applicationId: jointHolder?.data?.accountList?.[0]?.id }))
              dispatch({ type: VERIFY_LOGIN_OTP_SUCCESS, body: { ...tokenWithCompanyRes, diyInvestorOnboardingEdit: showDiyInvestorOnboarding, diyInvOnboardingPrev: showDiyInvOnboardingPrev } })


              if (showDiyInvestorOnboarding) {
                dispatch(showError("Please complete your onboarding journey"))
                history.replace('/investor-onboarding-application/rm-details', { id: jointHolder?.data?.accountList?.[0]?.id });
              }
            }

          } else {

            history.push('joint-holder', {
              ...res,
              jointHolderData: jointHolder.data.accountList

            })
          }
        }
      } else {
        dispatch({ type: VERIFY_LOGIN_OTP_SUCCESS, body: res });
      }

    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
      resetForm();
    }
  };

  useEffect(() => {
    const { verificationToken } = location.state || {};
    if (!location.state) {
      history.push('/login');
    }
    setVerifyOtpInfo({ verificationToken });
  }, []);

  const onResend = async () => {
    try {
      setLoading(true)
      if (loginType === 'payment') {
        const response = (await dispatch(
          getOtpForPaymentFlow(referenceId)
        )) as unknown as GetOtpForInvestorResponse;
        setVerifyOtpInfo({ ...response });
        return;
      }
      if (loginType === 'investor') {
        const response = (await dispatch(
          getOtpForInvestor(referenceId)
        )) as unknown as GetOtpForInvestorResponse;
        setVerifyOtpInfo({ ...response });
        return;
      }
      if (isEmailVerificationRequired) {
        const res = await dispatch(verifyLoginEmail({
          phone: unMaskedPhone ?? "",
          countryCode: countryCode ?? "",
          email: unMaskedEmail ?? "",
          userId: Number(userId ?? ""),
          userRole: userRole ?? ""
        }) as unknown as Promise<VerifyLoginEmailResponseBody>)

        setVerifyOtpInfo({ ...res });
      } else {
        const res = (await dispatch(
          loginWithOtp({
            phone: unMaskedPhone ?? "",
            countryCode: countryCode ?? ""
          })
        )) as unknown as LoginWithOtpResponseBody;
        setVerifyOtpInfo({ ...res });
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(prevState => !prevState);
  }

  return (
    <LoginLayout LoginText="Login with OTP">
      <Formik initialValues={intialValues} onSubmit={handleSubmit}>
        {({ values, setValues, handleSubmit }) => (
          <Box component="form" noValidate onSubmit={handleSubmit} aria-label="OTP verification form">
            <Box
              sx={(theme: Theme) => ({
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                textAlign: "center",
                color: theme.palette.primary.main,
                mb: 2,
                columnGap: "4px",
                rowGap: "2px",
                fontSize: { xs: "14px", sm: "16px" },
                lineHeight: 1.4,
              })}
            >
              <Typography component="span">
                An OTP has been sent
              </Typography>

              <Typography component="span" >
                to your mobile number
              </Typography>

              <Typography component="span" >
                {` ${phone} `}
              </Typography>

              {email && (
                <>
                  <Typography component="span" >
                    and email Id{' '}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ wordBreak: "break-word" }}
                  >
                    {' '}
                    {email}
                  </Typography>
                </>
              )}
            </Box>


            <Box
              sx={{
                mb: 0,
                '.otp-input': {
                  input: {
                    width: { xs: '37px !important', md: '45px !important' },
                    fontSize: { xs: '20px !important', md: '30px !important' },
                    margin: { xs: '2px !important', md: '4px !important' },
                  },
                },
              }}>
              <OtpInput
                inputType='number'
                renderInput={(inputProps: InputProps, index: number) => <input {...inputProps} type={isPasswordVisible ? 'text' : 'password'} style={{ ...inputProps.style }} disabled={isLoading} aria-label={`OTP digit ${index + 1} of 6`} />}
                value={values.OTP}
                // isDisabled={isLoading}
                onChange={(OTP: string) => setValues({ OTP })}
                numInputs={6}
                // hasErrored={!!error}
                // isInputNum={true}
                // isInputSecure={true}
                shouldAutoFocus={true}
                containerStyle={{
                  display: 'flex',
                  justifyContent: 'center',
                  // flexWrap: 'wrap',
                }}
                inputStyle={{
                  width: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  height: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  // padding: '5px 10px',
                  // // width: '45px',
                  borderRadius: '5px',
                  fontSize: !isSm ? '22px' : '30px',
                  borderColor: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                  color: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                  outline: 'none'
                }}
                renderSeparator={() => (
                  <span style={{ width: '6px' }}></span>
                )}

              // errorStyle={{ border: '2px solid red', color: 'red' }}
              // focusStyle={{ outline: 'none' }}
              // className="otp-input"
              />
              {!!error && (
                <FormHelperText error sx={{ mt: 2, textAlign: 'center', fontSize: '14px' }} role="alert" aria-live="assertive">
                  {error}
                </FormHelperText>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "0.5rem",
              }}
            >
              <IconButton
                sx={{
                  display: "flex",
                  columnGap: "0.5rem",
                  borderRadius: "1rem",
                }}
                onClick={togglePasswordVisibility}
                disabled={isLoading}
                aria-label={isPasswordVisible ? "Hide OTP" : "Show OTP"}
              >
                {isPasswordVisible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                <Typography
                  variant='subtitle_600'
                  sx={{
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                  }}
                >
                  {isPasswordVisible ? "Hide OTP" : "Show OTP"}
                </Typography>
              </IconButton>
            </Box>
            <Box
              sx={{
                '.MuiTypography-root, .MuiButton-root': {
                  textAlign: 'center',
                },
              }}>
              <OtpTimer onResend={onResend} />
            </Box>
            <Box
              sx={{
                fontSize: 14,
                color: '#c53030',
                textAlign: 'center',
                // marginBottom: -2,
                marginTop: 2,
                marginBottom: 2
              }}>
              Note: User Account will be locked after 3 unsuccessful attempts, Resend otp can be
              requested 2 times for every hour
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <MFSubmitButton label="Submit" loadingEnable={isLoading} />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '10px', gap: '5px' }}>
              <InfoIconOutlined />
              <Typography variant='overline_400'>
                Keep Your Password/Pin/OTP private & confidential to avoid any misuse or unauthorised trades.
              </Typography>
            </Box>
          </Box>
        )}
      </Formik>
    </LoginLayout>
  );
}
